<template>
    <div>
        <el-dialog :visible.sync="deviceDetailDialog" width="40%" top="13vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false v-loading="loading"  element-loading-text="请求处理中" element-loading-spinner="el-icon-loading"  
               element-loading-background="rgba(0.8, 0, 0, 0.3)" @close="closeDialog">
            <el-card style="height: 550px">
                <el-tabs type="border-card" v-model="activceName">
                    <el-tab-pane label="资产位置" name="1">
                        <el-form ref="dateForm" label-width="85px" label-position="left">
                            <el-row>
                                  <el-divider content-position="left">代理信息</el-divider>
                            </el-row>  
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="代理名称">{{response.data.csName}}</el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="代理类型">{{response.data.csType}}</el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="代理类型">{{response.data.csPhone}}</el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                  <el-divider content-position="left">BD信息</el-divider>
                            </el-row>  
                             <el-row>
                                <el-col :span="12">
                                    <el-form-item label="BD名称">{{response.data.bdName}}</el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="BD电话">{{response.data.bdPhone}}</el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                  <el-divider content-position="left">门店信息</el-divider>
                            </el-row>  
                             <el-row>
                                <el-col :span="12">
                                    <el-form-item label="门店编号">{{response.data.storeCode}}</el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="门店名称">{{response.data.storeName}}</el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item>
                                         <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;联系人</label>{{response.data.storeContactName}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="联系电话">{{response.data.storeContactPhone}}</el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="流转记录" name="2">
                         <el-table :data="response.data.assetPowerBoxDeployHisDtoList"  v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" 
                                   style="margin:auto;width:calc(100% - 30px)" height="450" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                                   :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
                            <el-table-column label="设备编号" align="center" prop="powerBoxId"></el-table-column>
                            <el-table-column label="操作类型" align="center" prop="operationType"></el-table-column>
                            <el-table-column label="门店名称" align="center" prop="storeName"></el-table-column>
                            <el-table-column label="操作人" align="center" prop="operationPerson"></el-table-column>
                            <el-table-column label="操作时间" align="center" width="180">
                                <template slot-scope="scope">{{ scope.row.operationTime | formatDate}}</template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </el-dialog>
    </div>
</template>
<script>
import {getDeviceInfoById} from "../../../api/warehousedevice/warehousedevice.js";
import { formatDate } from "../../../utils/date.js";
export default {
    data() {
        return {
            
            response: {data: '',total: 0},
            loading: false,
            deviceDetailDialog: false,
            activceName: "1"
        }
    },
    methods: {
        init(deviceId){
            this.deviceDetailDialog = true;
            getDeviceInfoById(deviceId).then(result=>{
                if(result.data != null){
                    this.response.data = result.data;
                }
            })
        },

        /**
         * 关闭弹窗
         */
        closeDialog(){
            this.activceName = "1";
            this.response.data = ''
        } 
    },
    filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  },
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/warehouse/warehousedevice/devicedetail.vue